import { motion } from 'framer-motion';
import React from 'react';

const SocialMediaIcons: React.FC = () => {
  const IG_LOGO = 'https://santaplaya-bucket.s3.amazonaws.com/ig-logo.webp';
  const X_LOGO = 'https://santaplaya-bucket.s3.amazonaws.com/x-logo.webp';
  const FB_LOGO = 'https://santaplaya-bucket.s3.amazonaws.com/fb-logo.webp';
  return (
    <div className="flex flex-row space-x-4 items-center">
      <motion.a
        href="https://www.facebook.com/profile.php?id=61569020525577"
        target="_blank"
        rel="noopener noreferrer"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
      >
        <img src={FB_LOGO} alt="Facebook" className="h-8 w-auto" />
      </motion.a>
      <motion.a
        href="https://www.instagram.com/santa_playa_mariscos/"
        target="_blank"
        rel="noopener noreferrer"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
      >
        <img src={IG_LOGO} alt="Instagram" className="h-8 w-auto" />
      </motion.a>
      <motion.a
        href="https://x.com/Noozhawk/status/1839697610686267729"
        target="_blank"
        rel="noopener noreferrer"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
      >
        <img src={X_LOGO} alt="X" className="h-8 w-auto" />
      </motion.a>
    </div>
  );
};

export default SocialMediaIcons;
